import React from 'react';
import Footer from "../../components/footer";
import Header from "../../components/header";

class FaqPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            one: false,
            two: false,
            three: false,
            four: false,
            five: false,
            six: false
        }
    }

    clickQuestion = (e) => {
        e.preventDefault();
        if (e.target.className === "active") {
            this.setState({
                one: false,
                two: false,
                three: false,
                four: false,
                five: false,
                six: false
            })
        } else {
            switch (e.target.name) {
                case "1":
                    this.setState({
                        one: true,
                        two: false,
                        three: false,
                        four: false,
                        five: false,
                        six: false
                    })
                    break;
                case "2":
                    this.setState({
                        one: false,
                        two: true,
                        three: false,
                        four: false,
                        five: false,
                        six: false
                    })
                    break;
                case "3":
                    this.setState({
                        one: false,
                        two: false,
                        three: true,
                        four: false,
                        five: false,
                        six: false
                    })
                    break;
                case "4":
                    this.setState({
                        one: false,
                        two: false,
                        three: false,
                        four: true,
                        five: false,
                        six: false
                    })
                    break;
                case "5":
                    this.setState({
                        one: false,
                        two: false,
                        three: false,
                        four: false,
                        five: true,
                        six: false
                    })
                    break;
                case "6":
                    this.setState({
                        one: false,
                        two: false,
                        three: false,
                        four: false,
                        five: false,
                        six: true
                    })
                    break;
                    default:
                    break;
            }
        }
    }
    render() {
       // const { one, two, three, four, five, six } = this.state;

        return (
            <>
                <div class="registration-wrapper">

                    <Header routes={[{ "name": "Login", "route": "/login", },{ "name": "FAQ", "route": "/FaqPage", }]} />
                    {/* <!-- Content Section --> */}
                    <div class="register-content">
                        <div class="container faqpage">

                            <h2>Frequently Asked Questions</h2>
           <div class="row">
                        <div class="col-lg-12">
                            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingzero">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsezero" aria-expanded="false" aria-controls="collapsezero">
                                            Is my information protected?
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapsezero" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingzero">
                                        <div class="panel-body">
                                            <p>Yes. We use 256 bit SSL encryption and use Amazon Web Service HIPAA secure servers. ePaper road is in full compliance with US Federal and State Privacy and Security regulations and guidelines. Your information is encrypted, deidentified and segregated from the rest of our database.</p>
                                            
        
                                        </div>
                                    </div>
                                </div>
        
        
        
        
        
        
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingOne">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                            How do you protect my information if I decide to use the fax option?
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseOne" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
                                        <div class="panel-body">
                                            <p>Our electronic faxing system is HIPAA compliant in accordance with the Federal rules for privacy and security of protected health information. We do rely of you to provide the correct fax number and cannot be held responsible if you do not provide the correct information.
                                            </p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingTwo">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Do you store my medical records?
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                        <div class="panel-body">
                                            <p>We keep your medical records on our HIPAA secure server for 30 days from the time of the completion of your request. After that the files are deleted. This gives you 30 days to download the records and secure them yourself.
                                            </p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingThree">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            Do you store any credit card information?
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                        <div class="panel-body">
                                            <p>We do not store your credit card information anywhere on our system. It is not accessible by any of our employees. Credit cards kept for multiple requests and recurrent charges are stored on the servers of our credit card processing company, Fattmerchant, which is a located in the United States.</p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingfour">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                                            I need records transferred from my physician to someone they referred me to and I do not think I should pay for it.
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapsefour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingfour">
                                        <div class="panel-body">
                                            <p>In this case, you would contact the physician’s office directly. The vast majority of physician’s office will not charge you to send the records over under this circumstance. In fact, charging for records associated with peer to peer referrals is prohibited in certain states.</p>
                                        </div>
                                    </div>
                                </div>

                                  <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingfour">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsefive" aria-expanded="false" aria-controls="collapsefour">
                                            How are the fees determined?
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapsefive" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingfour">
                                        <div class="panel-body">
                                            <p>Our fees, including those associated with postage, are generated in accordance with the laws of the state in which the custodian of records is located (ie where the originating physician’s office is located). Additional charges such as rush processing and administrative fees for certain requestors are our company policy.</p>
                                        </div>
                                    </div>
                                </div>
        
                            
                                
        
                             
                                
        
                          
        
                               
        
                               
        
                             
        
        
                               
        
                            
                               
                            </div>
                        </div>
                    </div>

                        </div>
                    </div>
                </div>

                {/* <!-- Footer Section --> */}
                <Footer />
            </>
        )
    }


}

export default FaqPage;